<template>
  <div class="col-12 pt-5">
    <div class="row">
      <div class="tag-badge-info d-flex justify-content-start">
        <div class="circle">
          <div class="text-white">
            {{ config.name | extractNumber }}
          </div>
        </div>
        <span class="tag-badge-title-info pl-3">
          {{ config.name | extractTitle }}
        </span>
      </div>
    </div>
    <div class="row">
      <div
        class="custom-square"
        style="margin-left:38px;"
        v-html="config.description"
      />
    </div>
    <div
      v-for="(preQuestion, index) in config.preQuestions"
      :key="`pre${preQuestion.id}-${index}`"
    >
      <PreQuestion
        :question-id="questionId"
        :pre-question="preQuestion"
        :evidences="evidences"
        :disabled="preIsSubmitted"
      />
    </div>
    <div v-if="showPosQuestions">
      <div
        v-for="(postQuestion, index) in config.postQuestions"
        :key="`post${postQuestion.id}-${index}`"
      >
        <PostQuestion
          :post-question="postQuestion"
          :evidences="evidences"
          :answer-numerals="getAnswerNumerals()"
          :disabled="postIsSubmitted && preIsSubmitted"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.bottom-margin {
  margin-bottom: 15px;
}

ul li {
  list-style-type: none;
  color: black;
  opacity: 1;
}

.custom-square >>> ul {
  margin-top: 15px;
}
.custom-square >>> li p::before {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  content: '\f00c';
  margin-right: 10px;
  color: #2db782;
}

.custom-square >>> li {
  list-style: none;
}

.circle {
  display: flex;
  border: 3px solid #fff;
  border-radius: 50%;
  min-width: 30px;
  min-height: 30px;
  justify-content: center;
  align-items: center;
  background: #2db782;
  margin-left: 0px;
  margin-right: -7px;
}
</style>

<script scoped>
import PreQuestion from './PreQuestion';
import PostQuestion from './PostQuestion';
import resourcesService from '@/services/resources.js';

export default {
  name: 'InterventionQuestion',
  components: {
    PreQuestion,
    PostQuestion,
  },
  filters: {
    extractNumber(value) {
      return value[0];
    },
    extractTitle(value) {
      return value.slice(2).trim();
    },
  },
  data() {
    return {
      description: this.config.description,
    };
  },
  props: {
    questionId: {
      type: Number,
      required: true,
    },
    config: {
      type: Object,
      default: () => {},
    },
    evidences: {
      type: Array,
      default: () => [],
    },
    showPosQuestions: {
      type: Boolean,
      default: () => false,
    },
    preIsSubmitted: {
      type: Boolean,
      default: () => false,
    },
    postIsSubmitted: {
      type: Boolean,
      default: () => false,
    },
  },
  async created() {
    await this.loadResources();
  },
  methods: {
    async loadResources() {
      let result = await resourcesService.LoadValidationMessages(['R03200105']);

      if (!this.description) this.description = result['R03200105'];
    },
    getAnswerNumerals() {
      return this.config &&
        this.config.preQuestions &&
        this.config.preQuestions.length > 0
        ? this.config.preQuestions[0].answers
        : [];
    },
    inValidNumber(_number) {
      return null == _number || isNaN(_number) || _number < 0;
    },
  },
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 768px) {
  .tag-badge-info {
    height: auto !important;
    display: flex;
    align-items: center;
  }
  .circle {
    width: 25px;
    height: 25px;
    margin-left: 5px;
  }
}
</style>
